export default __webpack_public_path__ + "images/image5.10c57e7f.png";